import { render } from "./ShopCodes.vue?vue&type=template&id=10a3b9e8"
import script from "./ShopCodes.vue?vue&type=script&lang=ts"
export * from "./ShopCodes.vue?vue&type=script&lang=ts"
script.render = render

export default script